import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import TableCell from '@mui/material/TableCell';

import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import EditIcon from '@mui/icons-material/Edit';
import CopyIconButton from '../../../../components/_iconButton/CopyIconButton';
import useRoutes from '../../../../components/_hook/useRoutes';
import FormManagePlanSubdirectorySubscription from './_module/FormManagePlanSubdirectorySubscription';
import SchemaCompanyName from '../../../../components/_schema/SchemaCompanyName';
import Moment from '../../../../components/Moment';
import { ICompanySubdirectorySubscriptionSchema } from '../../../../../graphql/type/companySubdirectorySubscription';

interface IProps {
  item: ICompanySubdirectorySubscriptionSchema;
  setTableRefreshKey?: (tableRefreshKey: number) => void;
}

export default function PlanSubdirectorySubscriptionTableItem(props: IProps) {
  const { t } = useTranslation();
  const { item, setTableRefreshKey } = props;
  const { path } = useRoutes();
  const [isShowDialogManage, setIsShowDialogManage] = useState(false);

  return (
    <>
      <Dialog
        open={isShowDialogManage}
        maxWidth="sm"
        fullWidth
        onClose={() => setIsShowDialogManage(false)}
      >
        <FormManagePlanSubdirectorySubscription
          companySubdirectorySubscriptionId={item._id}
          onComplete={() => {
            if (setTableRefreshKey) {
              setTableRefreshKey(new Date().getTime());
            }
          }}
          onCancel={() => setIsShowDialogManage(false)}
        />
      </Dialog>
      <TableCell align="left">
        <Tooltip title={item._id}>
          <span>{item._id.substr(0, 6)}</span>
        </Tooltip>
        <CopyIconButton iconHtmlFontSize="0.8rem" copyText={item._id} />
      </TableCell>
      <TableCell align="center">
        {item.subdirectoryData &&
          item.subdirectoryData.domain &&
          item.subdirectoryData.domain.map((domain) => (
            <React.Fragment key={domain}>
              <Button
                color="primary"
                component="a"
                href={`//${domain}`}
                target="_blank"
              >
                <Typography>{domain}</Typography>
              </Button>
              <br />
            </React.Fragment>
          ))}
      </TableCell>
      <TableCell align="center">
        {item.subdirectoryData && item.subdirectoryData.status ? (
          <>{item.subdirectoryData.status ? t('active') : t('inactive')}</>
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell align="center">
        {item.subdirectoryData && item.subdirectoryData.companyData && (
          <SchemaCompanyName
            useIndexLink
            company={item.subdirectoryData.companyData}
          />
        )}
      </TableCell>
      <TableCell align="center">
        {item.status ? t('active') : t('inactive')}
      </TableCell>
      <TableCell align="center">
        {item.expiryDate ? <Moment time={item.expiryDate} dateOnly /> : '-'}
      </TableCell>
      <TableCell align="right">
        <Button
          variant="contained"
          onClick={() => {
            setIsShowDialogManage(true);
          }}
          startIcon={<EditIcon />}
        >
          {t('manage')}
        </Button>
      </TableCell>
    </>
  );
}
